export const CFCardSerialValidator = (value: string) => {
    return !/^(\d{4,5})$/.test(value) ? 'Invalid card serial number' : undefined;
}
